import React,{useState,useRef} from 'react';
import './ProjectControlTab.css';
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ProjectMasterNew from './ProjectMasterNew';
import Others from './Others';
import Grid from '@mui/material/Grid';
import { Button } from "@mui/material";
import ModalPopup from "./AddNewProjectModal";
import ProjectMaster from './ProjectMaster';
import { useDispatch } from "react-redux";
import {downloadCategory,uploadProjectMaster} from "../function-components/Redux/ProjectMasterSlice";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
   
    return (
     <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
     >
      {value === index && (
       <Box sx={{ p: 2 }}>
        <Typography>{children}</Typography>
       </Box>
      )}
     </div>
    );
   }
   
   TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
   };
   
   function a11yProps(index) {
    return {
     id: `simple-tab-${index}`,
     "aria-controls": `simple-tabpanel-${index}`,
    };
   }


const ProjectControlTab = () => {
const [value, setValue] = React.useState(0);
 const handleChange = (event, newValue) => {
  setValue(newValue);
 };
 const dispatch = useDispatch();
 const [file, setFile] = useState("");
 const ref = useRef();

 const uploadFile = () => {
  const formData = new FormData();
  formData.append("file", file);
  dispatch(uploadProjectMaster(formData));
 };

 const saveFile = (e) => {
    e.preventDefault();
    setFile(e.target.files[0]);
  };

    const handleDownload = () => {
        dispatch(downloadCategory());
    }

    return (
        <>
    <div className="main-container">
    <Box sx={{width:"93.5%",margin:"auto",paddingTop:"60px"}}>
        <Grid container spacing={2} sx={{width: "100% !important",marginLeft: "0 !important"}}>
        <Grid  xs={10}>
        <Typography sx={{fontWeight: "bold", fontSize: "24px"}}>Project Control Center</Typography>
        </Grid>
        <Grid  xs={2} sx={{textAlignLast: "end"}}>        
        </Grid>
        </Grid>
    </Box>
    <div className='download_add_container'>                
        <div className="download_button" onClick={handleDownload}>
            <img src="/images/projectMaster/Icon metro-file-excel.png" alt="download_icon" />
            <span className="download_span1">Generate Full Report</span>
        </div>
        <Button className="addNewProject_button">                
            <ModalPopup
            setValue={setValue}
            />
        </Button>   
        {/* <div
      className="file-upload"
      style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
     >
      <input
       type="file"
       className="mainData"
       accept=".xlsx"
       ref={ref}
       id="file"
       onChange={saveFile}
       hidden
      />
      <label for="file" className="custom-upload-btn">
       Select File
      </label>
      <span className="file_caption">
       {file.name != undefined && file.name != null ? file.name : "No File Selected"}
      </span>
            </div> */}
        {/* <div className="download_button" >
 
            <span className="download_span1" onClick={uploadFile}>Upload</span>
        </div>      */}
    </div>    
    <Box className="boxStyles">
     <Box sx={{ borderColor: "divider" }} className="tabMenuWrap">
      <Tabs
       value={value}
       onChange={handleChange}
       aria-label="basic tabs example"
       centered
      >
       <Tab label="Projects" {...a11yProps(0)} className="tabStyles" />
       <Tab label="Power App/BI" {...a11yProps(1)} className="tabStyles" />
       <Tab label="Change Request" {...a11yProps(2)} className="tabStyles" />
       <Tab label="Others" {...a11yProps(3)} className="tabStyles" />
      </Tabs>
     </Box>
     <TabPanel className="tabPanelWrap" value={value} index={0}>
        <ProjectMasterNew requestType="Portal-Wireframe" />        
     </TabPanel>
     <TabPanel className="tabPanelWrap" value={value} index={1}>
         <ProjectMasterNew requestType="PowerBI-PowerApp" />
     </TabPanel>
     <TabPanel className="tabPanelWrap" value={value} index={2}>
        <ProjectMasterNew requestType="CR"/>
     </TabPanel>
     <TabPanel className="tabPanelWrap" value={value} index={3}>
        <ProjectMasterNew requestType="OTH" />
     </TabPanel> 
    </Box>
   </div>
    </>
    )
}

export default ProjectControlTab;